import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Big from 'UIComponents/elements/Big';
import { H2, H3 } from 'UIComponents/elements/headings';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIImage from 'UIComponents/image/UIImage';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
// @ts-expect-error untype dependency
import customizeImageUrl from 'bender-url!marketplace-assets-base/img/templates-homepage/customize-website-icon.svg'; // @ts-expect-error untype dependencys

import standOutImageUrl from 'bender-url!marketplace-assets-base/img/templates-homepage/stand-out-icon.svg';
import { getModulesStorefrontRoute } from '../../utils/urls';
export default function ModulesSection({
  onTrackInteraction
}) {
  const {
    direction,
    width
  } = useResponsiveProps({
    direction: {
      [ScreenSizes.XS]: 'column',
      [ScreenSizes.MD]: 'row'
    },
    width: {
      [ScreenSizes.XS]: undefined,
      [ScreenSizes.MD]: '50%'
    }
  });
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    className: "p-y-10 p-x-5",
    direction: "column",
    children: [/*#__PURE__*/_jsx(H2, {
      className: "text-center is--heading-1",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.templates.modules.title"
      })
    }), /*#__PURE__*/_jsxs(UIFlex, {
      direction: direction,
      className: "m-right-0  p-all-10",
      justify: "center",
      children: [/*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        className: "m-right-4",
        direction: "column",
        style: {
          width
        },
        children: [/*#__PURE__*/_jsx(UIImage, {
          className: "p-bottom-10",
          height: 180,
          responsive: false,
          src: customizeImageUrl
        }), /*#__PURE__*/_jsx(H3, {
          className: "text-center",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.templates.modules.customizeTitle"
          })
        }), /*#__PURE__*/_jsx("p", {
          className: "text-center",
          children: /*#__PURE__*/_jsx(Big, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.templates.modules.customizeSubtitle"
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        className: "m-left-4",
        direction: "column",
        style: {
          width
        },
        children: [/*#__PURE__*/_jsx(UIImage, {
          className: "p-bottom-10",
          height: 180,
          responsive: false,
          src: standOutImageUrl
        }), /*#__PURE__*/_jsx(H3, {
          className: "text-center",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.templates.modules.standOutTitle"
          })
        }), /*#__PURE__*/_jsx("p", {
          className: "text-center",
          children: /*#__PURE__*/_jsx(Big, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.templates.modules.standOutSubtitle"
            })
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(UIRouterButton, {
      className: "m-top-4",
      onClick: () => {
        onTrackInteraction('click modules storefront link');
      },
      style: {
        width
      },
      to: getModulesStorefrontRoute(),
      use: "tertiary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.templates.modules.button"
      })
    })]
  });
}